<template>
  <div class="h-full / flex flex-col gap-2 items-center justify-center / bg-gray-900 text-white text-xs cursor-default">
    <CalendarIcon class="h-5 w-5" />
    <div v-if="person" class="whitespace-normal text-center">
      Book meetings with<br />
      {{ person.name }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DeepReadonly, PropType } from 'vue'
import { CalendarIcon } from '@heroicons/vue/24/solid'
import type { Slide } from '@/entities/deck'

const props = defineProps({
  slide: {
    type: Object as PropType<DeepReadonly<Slide>>,
    required: true,
  },
})

const person = computed(() => {
  const requestSetting = props.slide.request_setting
  if (!requestSetting) return null
  const { person, user } = requestSetting
  return {
    name: person?.name || user?.name,
  }
})
</script>
